import React from "react";
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  return (
    <div className="container">
      <div className="card policy-card">
        <Link to="/" className="back-link">
          &larr; Back
        </Link>

        <h1>Privacy Policy</h1>

        <p>ClaimLion Law is a trading style of BlackLion LLP.</p>
        <p>
          This privacy policy sets out how ClaimLion Law, collects, uses and
          protects your information when you use this website or our services,
          in accordance with the Data Protection Act 2018 and the UK General
          Data Protection Regulation (UK GDPR).
        </p>
        <p>
          ClaimLion Law is the controller and is responsible for your personal
          data. We are committed to ensuring that your privacy is protected. By
          using our website and/or our services, you may be providing us with
          some of your personal information and we want to make sure that we do
          not use your data in a way that you would not expect. ClaimLion Law
          assure you that your personal information will only be used in
          accordance with this privacy policy and in compliance with the latest
          privacy regulations.
        </p>
        <p>
          ClaimLion Law may change this policy in future by updating this page.
          You should check this page from time to time to ensure that you are
          happy with any changes. This policy is effective from 24th February
          2026.
        </p>

        <h2>Personal Information We Collect</h2>
        <p>
          Personal information is any information about an individual from
          which that person can be identified. It does not include data which
          has been anonymised.
        </p>
        <p>
          We may collect, use, store and transfer different kinds of personal
          data about you which we have grouped together as follows:
        </p>
        <ul>
          <li>
            <strong>Contact information:</strong> Name, current and previous
            addresses (including postal, email and IP addresses) and telephone
            numbers
          </li>
          <li>
            <strong>Identity Data</strong> includes first name, maiden name,
            last name, username or similar identifier, marital status, title,
            date of birth and gender.
          </li>
          <li>
            <strong>Financial Data:</strong> includes information on your
            financial circumstances, the lenders or financial institutions used
            by you, the financial products you have taken out and the details
            and status of those financial products.
          </li>
          <li>
            <strong>Usage Data</strong> includes information about how you use
            our website, products and services. This may include your IP
            address, geographical location, browser type and version, operating
            system, referral source, length of visit, page views and website
            navigation paths, as well as information about the timing,
            frequency and pattern of your service use. The source of the usage
            data is our analytics tracking system.
          </li>
          <li>
            <strong>Marketing and Communications Data</strong> includes your
            preferences in receiving marketing from us and our third parties
            and your communication preferences.
          </li>
          <li>
            <strong>Special Category Data:</strong> We will only process
            special category data where you have provided this to us and given
            your explicit consent to store it or we have a legal/regulatory
            obligation to. This includes race or ethnicity, religious or
            philosophical beliefs, sex life, sexual orientation, political
            opinions, trade union membership, information about your health
            and genetic and biometric data.
          </li>
        </ul>
        <p>
          This list may not include all the information we require when
          providing our service/s. The information we ask you for will relate
          to your specific enquiry and will only consist of the information we
          need to carry out our service. If you contact us other than via our
          website, we will keep a record of that correspondence and a copy of
          call recordings.
        </p>

        <h2>Method of collection</h2>
        <ul>
          <li>
            <strong>Direct interactions:</strong> By you filling in forms on
            our website or social media or by corresponding with us by post,
            phone, email or otherwise.
          </li>
          <li>
            <strong>Third parties or public sources:</strong> We may receive
            information about you from various reputable third-party lead
            providers, from our regulators, your lenders, DVLA or from
            publicly available data.
          </li>
          <li>
            <strong>Credit Information Firms:</strong> We may verify your
            identity through third party credit information firms who will
            carry out a soft credit search. We will always obtain your consent
            to do this, and it will not affect your credit score in any way.
          </li>
          <li>
            We will always inform you where we have obtained your information
            from if requested by you.
          </li>
        </ul>

        <h2>The basis on which we process your information</h2>
        <p>
          The legal grounds for processing your personal information depend
          upon the nature of our relationship with you and the context of
          processing and are as follows:
        </p>
        <ul>
          <li>
            Processing is necessary for the performance of a contract with
            you, or to take steps prior to entering into a contract with you.
          </li>
          <li>
            Processing is necessary for the purposes of your legitimate
            interests or our legitimate interests, where your fundamental
            rights and interests do not override those interests. In order to
            determine this, we shall undertake a Legitimate Interests
            Assessment and balancing test.
          </li>
          <li>
            Processing is necessary for compliance with mandatory legal or
            regulatory obligations to which we are subject.
          </li>
          <li>
            Processing is undertaken after you have given us your express
            consent.
          </li>
        </ul>

        <h2>What we use your personal information for</h2>
        <p>We collect/store or use your information to:</p>
        <table className="policy-table">
          <thead>
            <tr>
              <th>Purpose</th>
              <th>Legal basis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>provide the service you have requested</td>
              <td>Contract</td>
            </tr>
            <tr>
              <td>
                obtain information from credit information firms to identify
                and support your claims
              </td>
              <td>Consent</td>
            </tr>
            <tr>
              <td>
                send to our service providers/contractor partners (including,
                but not limited to, compliance consultants, barristers,
                experts, marketing providers and funders)
              </td>
              <td>Contract and/or Legitimate Interests</td>
            </tr>
            <tr>
              <td>
                send you information or marketing about our products and
                services
              </td>
              <td>Legitimate Interests and/or Consent</td>
            </tr>
            <tr>
              <td>
                contact you where you fail to fully complete our online form
              </td>
              <td>Legitimate Interests and/or Contract</td>
            </tr>
            <tr>
              <td>
                provide reports, questionnaires, returns and declarations to
                our regulator
              </td>
              <td>Legal Obligation</td>
            </tr>
            <tr>
              <td>
                resolve complaints against us or the establishment, exercise
                or defence of legal claims
              </td>
              <td>Legitimate Interests and/or Legal Obligation</td>
            </tr>
            <tr>
              <td>
                gather feedback to enable us to improve our website, products
                and services
              </td>
              <td>Legitimate Interests</td>
            </tr>
            <tr>
              <td>
                verify your identity where we receive requests to access or
                change the information we hold about you
              </td>
              <td>Legal Obligation</td>
            </tr>
            <tr>
              <td>maintain our accounts and records</td>
              <td>Legal Obligation</td>
            </tr>
            <tr>
              <td>comply with legal and regulatory obligations</td>
              <td>Legal Obligation</td>
            </tr>
            <tr>
              <td>
                research and analyse trends to better understand how users are
                using our website and services in order to improve them
              </td>
              <td>Legitimate Interests</td>
            </tr>
            <tr>
              <td>
                inform you about changes in our services and important service
                related notices, such as security and fraud issues
              </td>
              <td>Legal Obligation</td>
            </tr>
            <tr>
              <td>
                maintaining insurance coverage, managing risks, or obtaining
                professional advice
              </td>
              <td>Legitimate Interests and/or Legal Obligation</td>
            </tr>
          </tbody>
        </table>

        <h2>Providing your personal data to others</h2>
        <p>
          We may disclose your data to one or more of our selected, upon your
          consent to do so, for the purpose of enabling them to contact you so
          that they can offer, market and provide relevant services to you.
          Each such third party will act as a data controller in relation to
          the data that we supply to it; and upon contacting you, each such
          third party will supply to you a copy of its own privacy policy,
          which will govern that third party's use of your personal data.
        </p>
        <p>
          We may disclose your personal data to insurers, compliance
          consultants and/or professional advisers in so far as reasonably
          necessary for the purposes of obtaining or maintaining insurance
          coverage, managing risks, obtaining professional advice, or the
          establishment, exercise or defence of legal claims, whether in court
          proceedings or in an administrative or out-of-court procedure.
        </p>
        <p>
          We may disclose personal data to our suppliers or subcontractors,
          such as external printers, IT service providers, credit information
          firms, admin companies, call centres, compliance consultants, legal
          advisers, professional experts and barristers.
        </p>
        <p>
          We may disclose personal data to our partner credit information
          firms, Valid8 IP Ltd and Valifi Ltd for the purposes of obtaining
          your credit file from one or more credit reference bureaus and you
          can view their privacy policies here:{" "}
          <a
            href="https://www.valid8.co.uk/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Valid8 | IP
          </a>
          {" "}
          <a
            href="https://www.valifi.co.uk/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Valifi
          </a>
          .
        </p>
        <p>
          With you consent we will carry out a soft credit search through
          Valid8 IP Ltd to identify and validate any potential claims you may
          have, and your information will be shared with the following credit
          reference bureaus:
        </p>
        <ul>
          <li>
            Equifax Ltd &ndash;{" "}
            <a
              href="https://www.equifax.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.equifax.co.uk
            </a>
          </li>
          <li>
            Experian Ltd &ndash;{" "}
            <a
              href="https://www.experian.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.experian.co.uk
            </a>
          </li>
          <li>
            TransUnion Information Group Limited -{" "}
            <a
              href="https://www.transunion.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.transunion.co.uk
            </a>
          </li>
        </ul>
        <p>
          If you'd like to understand how the credit reference bureaus use and
          share personal data (including the legitimate interests they pursue)
          please read the{" "}
          <a
            href="https://www.equifax.co.uk/privacy-hub/crain"
            target="_blank"
            rel="noopener noreferrer"
          >
            Credit Reference Agency Information Notice (CRAIN)
          </a>
          {" "}here{" "}
          <a
            href="https://www.equifax.co.uk/privacy-hub/crain"
            target="_blank"
            rel="noopener noreferrer"
          >
            Equifax
          </a>
          ;{" "}
          <a
            href="https://www.experian.co.uk/legal/crain/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Experian
          </a>
          ;{" "}
          <a
            href="https://www.transunion.co.uk/legal/privacy-centre/pc-credit-reference"
            target="_blank"
            rel="noopener noreferrer"
          >
            TransUnion
          </a>
          .
        </p>
        <p>
          Any external processors, who process your data on our behalf, are
          subject to a data processing agreement to ensure the safety and
          protection of your data. None of our processors are allowed to use
          your data for any other purposes than instructed by us.
        </p>
        <p>
          In addition to the specific disclosures of personal data set out in
          this Section, we may disclose your personal data where such
          disclosure is necessary for compliance with a legal obligation to
          which we are subject, or in order to protect your vital interests or
          the vital interests of another natural person.
        </p>
        <p>
          We may also disclose your personal data where such disclosure is
          necessary for the establishment, exercise or defence of legal
          claims, whether in court proceedings or in an administrative or
          out-of-court procedure.
        </p>
        <p>
          To assist us to provide our services to you we may use data
          processors that are outside of the European Economic Area (EEA).
          Robust and comprehensive due diligence is completed before we use
          any data processors outside the EEA. Where the country, territory,
          sector or international organisation that the transfer of personal
          data is being made has not got an EU Commission 'adequacy decision',
          the restricted transfer will only be made where there is an
          appropriate safeguard in place which will ensure that your rights
          and freedoms in respect of your personal data are protected. Please
          contact us if you need any further details about how we transfer
          personal data outside of the EEA and what safeguards are in place.
        </p>

        <h2>Marketing</h2>
        <p>
          You are provided with choices regarding marketing and we record your
          preferences in relation to this and how we communicate with you.
        </p>
        <p>
          We may rely on consent when we use your personal information for
          direct marketing. This will be where you have specifically consented
          to us or a third party that you are happy to receive marketing
          contact from us.
        </p>
        <p>
          We may also rely on legitimate interests for our direct marketing.
          Our legitimate interests are to inform individuals about products or
          services which may be of interest to them. Our legitimate interest
          may also be our commercial interests in operating our business,
          which includes acquiring new customers, providing additional
          services to existing or previous customers that are similar or
          aligned with previous products or services and, expanding our
          operations.
        </p>
        <p>
          You may also receive marketing communications from us if you have
          previously enquired about or purchased similar services from us and,
          in each case, you have not opted-out of receiving that marketing.
          This is known as a 'soft opt-in'.
        </p>
        <p>
          Such marketing communications may be in relation to claims
          management, legal services and financial services which could be
          done by post, email, SMS or telephone.
        </p>
        <p>
          To opt out of receiving future marketing under any lawful basis, or
          under soft opt in, in which we intend to rely on for direct
          marketing, please opt-out using the contact details provided in this
          privacy policy.
        </p>
        <p>
          If you require any further information about the lawful basis we
          have relied on to send direct marketing to you, please do not
          hesitate to contact us.
        </p>

        <h2>Cookies</h2>
        <p>
          A cookie is a small file of letters and numbers that we store on
          your browser or the hard drive of your computer if you agree. As you
          interact with our website, we may collect Technical Data and Usage
          Data about your equipment, browsing actions and patterns. We collect
          this personal data by using Third-Party cookies, specifically Google
          Analytics. You can view Google's privacy policy here:{" "}
          <a
            href="https://www.google.com/policies/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.google.com/policies/privacy
          </a>
          .
        </p>
        <p>
          Our website uses cookies to distinguish you from other users of our
          website. This helps us to provide you with a good experience when
          you browse our website and also allows us to improve our site.
        </p>
        <p>
          You will be asked to provide your consent for us to use cookies upon
          your first visit to our website.
        </p>
        <p>
          You can set your browser to refuse all or some browser cookies, or
          to alert you when websites set or access cookies. Also, to opt out
          of being tracked via Google Analytics, you can use Google's opt-out
          browser add-on:{" "}
          <a
            href="https://tools.google.com/dlpage/gaoptout"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://tools.google.com/dlpage/gaoptout
          </a>
        </p>
        <p>
          If you disable or refuse cookies, please note that some parts of
          this website may become inaccessible or not function properly.
        </p>

        <h2>How long do we keep your personal information</h2>
        <p>
          We retain your information for as long as is necessary for the
          purpose for which it was originally obtained. However, where we have
          provided a service, we will retain your information for 7 years from
          when the matter concluded.
        </p>
        <p>
          We have some legal and regulatory obligations to hold certain pieces
          of information for specific timeframes.
        </p>
        <p>
          We also need to keep some of your information for our accounting and
          reporting requirements.
        </p>
        <p>
          Your contact details will be held for the purposes of direct
          marketing for 3 years, this is to enable us to let you know about
          new products or services that may be of interest to you as detailed
          above.
        </p>

        <h2>Your Rights</h2>
        <p>
          You have the following rights in accordance with the UK GDPR and the
          DPA:
        </p>
        <ul>
          <li>To know that your data is being processed</li>
          <li>To access your personal data free of charge</li>
          <li>
            To have your information corrected if inaccurate (Including
            ensuring any third party puts right any inaccuracy)
          </li>
          <li>To request that your data be erased</li>
          <li>To restrict processing</li>
          <li>To request transfer of your data</li>
          <li>To object to processing and:</li>
          <li>To rights relating to automated decision making and profiling</li>
        </ul>
        <p>
          You may request that we to provide you with any personal information
          we hold about you. Where you send us a request to access your data,
          this will usually be free of change and sent to you within one month
          (unless your request is complex). However, we may charge a
          reasonable fee if your request is clearly unfounded, repetitive or
          excessive. Alternatively, we may refuse to comply with your request
          in these circumstances.
        </p>
        <p>
          We may need to request specific information from you to help us
          confirm your identity before we are able to process your request.
        </p>
        <p>
          We may withhold personal information that you request to the extent
          permitted by law.
        </p>
        <p>
          You may instruct us at any time not to process your personal
          information for marketing purposes.
        </p>
        <p>
          We may use automated decision making in our claims process and/or
          profiling in order to send you targeted marketing.
        </p>
        <p>
          You have the right to access details of the information we used to
          create your profile and the right to object to profiling, including
          profiling for marketing purposes.
        </p>
        <p>
          You have the right to request human intervention or challenge an
          automated decision.
        </p>
        <p>
          We do not use automated decision making which would produce legal or
          significant effects on individuals.
        </p>
        <p>
          If at any point you wish to raise a complaint regarding our data
          handling then you have the right to complain to the Information
          Commissioner's Office (ICO) the supervisory authority for data
          protection issues in the UK whose information is available at{" "}
          <a
            href="https://www.ico.org.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.ico.org.uk
          </a>
          . However, we would appreciate to opportunity to deal with any
          concerns directly with you in the first instance.
        </p>

        <h2>Security</h2>
        <p>
          ClaimLion Law recognise the personal nature of the information we
          collect, process and store. As we are committed to ensuring that
          your information is secure, we have put in place suitable physical,
          electronic and managerial procedures to prevent loss, unauthorised
          access, misuse or disclosure and to make sure that your information
          is safe and secure. If password access is required for certain
          parts of our website/application, you are responsible for keeping
          this password confidential.
        </p>

        <h2>Links to other websites</h2>
        <p>
          Our website may contain links to other websites of interest.
          However, once you have used these links to leave our site, you
          should note that we do not have any control over that other website.
          Therefore, we cannot be responsible for the protection and privacy
          of any information which may be collected or you provide whilst
          visiting such sites and such sites are not governed by this privacy
          statement. You should exercise caution and look at the privacy
          statement applicable to the website in question.
        </p>

        <h2>General and Opt out</h2>
        <p>
          You may not transfer any of your rights under this privacy policy to
          any other person. We may transfer our rights under this privacy
          policy where we reasonably believe your rights will not be affected.
        </p>
        <p>
          If any court or competent authority finds that any provision of this
          privacy policy (or part of any provision) is invalid, illegal or
          unenforceable, that provision or part-provision will, to the extent
          required, be deemed to be deleted, and the validity and
          enforceability of the other provisions of this privacy policy will
          not be affected. Unless otherwise agreed, no delay, act or omission
          by a party in exercising any right or remedy will be deemed a waiver
          of that, or any other, right or remedy.
        </p>
        <p>
          If you have any queries relating to our Privacy Policy or the
          personal data we hold about you, wish to opt out of marketing or you
          wish to invoke any of your legal rights, you can contact us by:
        </p>
        <ul className="contact-list">
          <li>
            <strong>Email:</strong> contactus@claimlionlaw.com
          </li>
          <li>
            <strong>Post:</strong> ClaimLion Law, 20-23 Mandela St, London NW1
            0DU
          </li>
          <li>
            <strong>Telephone:</strong> 0800 599 9993
          </li>
        </ul>

        <p className="last-updated">
          This policy is effective from 24th February 2026.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
